import { SwapBudget } from '@sorare/core/src/atoms/icons/SwapBudget';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';

type Props = {
  price?: Nullable<number>;
};

export const CommonCardPrice = ({ price = 10 }: Props) => {
  return (
    <LabelM bold>
      <Horizontal>
        <SwapBudget size={2} />
        {price}
      </Horizontal>
    </LabelM>
  );
};
